const QUICK = [
  {
    tag: "席位观察",
    title: "风向标候选人热评三连，评论区开始选边",
    digest: "近七十二小时提及量翻倍，讨论从「是谁」滑向「凭什么」。",
    hot: "88",
  },
  {
    tag: "提名线索",
    title: "深水区被曝手握多份「旧账底稿」，或成关键变量",
    digest: "此前压低的争议被重新翻出，多位观察者据此上调提名概率。",
    hot: "74",
  },
  {
    tag: "下一位预测",
    title: "临界点提前结束隐身：本周连发两条高能动态",
    digest: "沉寂三个月后首度公开亮相，争夺盘口随之剧烈波动。",
    hot: "69",
  },
];

export default function Hero() {
  return (
    <section id="watch" className="relative overflow-hidden">
      <div className="mx-auto max-w-[1280px] px-4 pt-10 md:px-6 md:pt-14">
        {/* issue + kicker */}
        <div className="flex items-center justify-between text-xs tracking-wide text-[#8a6b4f]">
          <span className="uppercase tracking-[0.3em]">Vol.114 · 王座观察季</span>
          <span className="hidden sm:inline">2026 · 第 38 周</span>
        </div>

        {/* headline block */}
        <div className="mt-5 border-y border-[#d9cbb2] py-7 md:mt-7 md:py-9">
          <p className="mb-3 text-sm font-semibold tracking-[0.2em] text-[#b03a2e]">
            本期观察 · THE CONTENDERS
          </p>
          <h1 className="font-display max-w-[900px] text-3xl font-black leading-snug text-[#18130e] md:text-5xl md:leading-tight">
            黑料王的下一张面孔，正从争议里站起身来
          </h1>
          <p className="mt-4 max-w-[760px] text-[15px] leading-relaxed text-[#4a4036] md:text-base">
            舆论从不缺王座，缺的是王座上新出现的那张脸。本周我们把散落在热搜、评论区与旧帖里的提名线索逐一拼合，盘点谁最接近"下一位黑料王"人选——附热度榜、存疑点与争夺时间线。
          </p>
        </div>

        {/* multi-card first screen */}
        <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-3 md:mt-8">
          {QUICK.map((q, i) => (
            <a
              key={q.title}
              href="#rank"
              className="group flex flex-col justify-between rounded-xl border border-[#e4d9c6] bg-[#fbf7ef] p-5 transition-colors hover:border-[#b03a2e] md:p-6"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className="rounded-full bg-[#e9dcc6] px-3 py-1 text-xs font-semibold text-[#6b4a2c]">
                    {q.tag}
                  </span>
                  <span className="font-display text-4xl font-black text-[#f0e3cc]">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display mt-4 text-lg font-bold leading-snug text-[#18130e] group-hover:text-[#8f2a20] md:text-xl">
                  {q.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[#4a4036]">{q.digest}</p>
              </div>
              <div className="mt-5 flex items-center gap-2 border-t border-dashed border-[#e0d2ba] pt-3 text-xs text-[#b03a2e]">
                <i className="ri-fire-fill"></i>
                <span>
                  热度指数 <b className="font-display text-sm">{q.hot}</b>
                </span>
                <span className="ml-auto text-[#8a6b4f]">展开线索 →</span>
              </div>
            </a>
          ))}
        </div>

        {/* cover strip */}
        <div className="mt-6 grid grid-cols-1 items-stretch gap-5 md:mt-8 lg:grid-cols-2">
          <a
            href="#feed"
            className="group relative h-[280px] overflow-hidden rounded-xl md:h-[360px]"
          >
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20newspaper%20cover%20collage%20on%20aged%20cream%20paper%20texture%2C%20dramatic%20studio%20lighting%2C%20bold%20red%20and%20ink%20black%20typography%20blocks%2C%20layered%20vintage%20print%20media%20pieces%20and%20newspaper%20clippings%2C%20magazine%20cover%20art%20direction%2C%20high%20contrast%20editorial%20graphic%20design&width=1200&height=760&seq=cover-editorial-01&orientation=landscape"
              alt="黑料王本期封面 王座争夺专题"
              title="黑料王王座观察专题封面"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#18130e]/80 via-[#18130e]/10 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <p className="text-xs font-semibold tracking-[0.25em] text-[#f0c8b6] uppercase">
                Cover Story
              </p>
              <h3 className="font-display mt-2 text-2xl font-black text-[#fbf7ef] md:text-3xl">
                王位为何总在争议最盛处更替
              </h3>
              <p className="mt-2 max-w-[560px] text-sm leading-relaxed text-[#f0e6d6] md:text-[15px]">
                从提名到加冕，只隔着一条旧帖与一片热搜的距离。本刊拆解近五年王座更替的公共规律。
              </p>
            </div>
          </a>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <a
              href="#nomi"
              className="group rounded-xl border border-[#e4d9c6] bg-[#fbf7ef] p-5 transition-colors hover:border-[#b03a2e]"
            >
              <span className="text-xs font-semibold tracking-wide text-[#b03a2e]">候选人 · 逆风者</span>
              <h4 className="font-display mt-3 text-xl font-bold leading-snug text-[#18130e] group-hover:text-[#8f2a20]">
                逆风翻盘型选手热度登顶
              </h4>
              <p className="mt-2 text-sm text-[#4a4036]">
                以「越被唱衰越被关注」的路径跻身第一梯队。
              </p>
              <div className="mt-4 text-xs font-medium text-[#8a6b4f]">读提名档案 →</div>
            </a>
            <a
              href="#rank"
              className="group rounded-xl border border-[#e4d9c6] bg-[#fbf7ef] p-5 transition-colors hover:border-[#b03a2e]"
            >
              <span className="text-xs font-semibold tracking-wide text-[#b03a2e]">榜单 · 周内变化</span>
              <h4 className="font-display mt-3 text-xl font-bold leading-snug text-[#18130e] group-hover:text-[#8f2a20]">
                回声室单周上升九位
              </h4>
              <p className="mt-2 text-sm text-[#4a4036]">
                一条旧录音被重新翻译，带动榜单一夜换名。
              </p>
              <div className="mt-4 text-xs font-medium text-[#8a6b4f]">查看完整热度榜 →</div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}